module.exports = __webpack_public_path__ + "media/images/icons/non-smartfone-active-76db98093d94f38dca27254bbc3e0804.png";